module.exports = __webpack_public_path__ + "img/dcl.ce41b210.svg";